export type RouteItem = {
  params: Record<string, any>;
  path: string;
  name: string;
};

export type User = {
  id: string;
  username: string;
  emailStatus: string;
  email: string;
};

export type UserRole = {
  profile: User;
  group: {
    name: 'owner' | 'admin' | 'member';
  };
};

export type ComponentBaseProps = {
  className?: string;
  style?: React.CSSProperties;
};

export type RouterProps = {
  route: Record<string, any>;
  params: Record<string, any>;
  componentFromRoute: Function;
};

// TODO (david): This is a subset of what will be a proper typing that will be used in SpaceModel
export type Content = {
  avatar?: {
    id: string;
    url: string;
  };
  title: string;
  slug: string;
  inSpace: Workspace;
};

export type Workspace = {
  id: string;
  parent?: Workspace;
  content: Content;
  spaceType: 'PROFILE' | 'INITIATIVE' | 'GLOBAL';
  path: string;
};

export enum ViewTypeEnum {
  Card = 'Card',
  List = 'List',
}

export type VoidFn = () => void;

export type DropDownItem = {
  text: string;
  key: string;
  value: string;
};
